<template>
    <div class="home-circle-chart-empty">
        <div class="header">
            <div class="title">
                空房率
                <word-tips-hover data="空房率 = 上架未租 / (已租＋上架未租)" width="266px"></word-tips-hover>
            </div>
            <div class="tips">
                <div>
                    <div class="dot empty"></div>
                    <div>空房 {{Object.keys(vacancyRate).length  !== 0 && vacancyRate.vacancyCount!==null?vacancyRate.vacancyCount:'-'}} 間</div>
                </div>
                <div>
                    <div class="dot"></div>
                    <div>全部 {{Object.keys(vacancyRate).length  !== 0 && vacancyRate.vacancyCount!==null && vacancyRate.rentedOutCount!==null?vacancyRate.vacancyCount+vacancyRate.rentedOutCount:'-'}} 間</div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="chart" :class="{'empty': !vacancyRate.vacancyRate}">
                <svg viewBox="0 0 36 36" class="circular-chart">
                    <path class="circle-bg"
                        d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path class="circle"
                        :stroke-dasharray="Math.round(vacancyRate.vacancyRate*100)+',100'"
                        d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                </svg>
                <div v-if="verifiedStatus === 'NORMAL'" class="percent">
                    {{Object.keys(vacancyRate).length  !== 0 && vacancyRate.vacancyRate!==null?Math.round(vacancyRate.vacancyRate*100):'-'}} %
                </div>
                <div v-else class="percent">
                    - %
                </div>
            </div>
            <div v-if="isAllGroup" class="analysis">
                <div class="list">
                    <div v-if="vacancyRate.compareToLastMonthRate" class="title">
                        您比上個月空房率{{compareLastMonthIsPositive?'多':'少'}}
                    </div>
                    <div v-else class="title">
                        上個月還沒有資料
                    </div>
                    <div class="up-low" :class="{'red': !compareLastMonthIsPositive, 'blue': compareLastMonthIsPositive}">
                        {{Object.keys(vacancyRate).length  !== 0 && vacancyRate.compareToLastMonthRate!==null?Math.round(Math.abs(vacancyRate.compareToLastMonthRate)*100):'-'}}％
                    </div>
                </div>
            </div>
            <div v-else class="analysis">
                <div class="list is-border">
                    <div class="title">
                        您比其他部門空房率{{compareOtherGroupIsPositive?'多':'少'}}
                    </div>
                    <div class="up-low" :class="{'red': !compareLastMonthIsPositive, 'blue': compareLastMonthIsPositive}">
                        {{Object.keys(vacancyRate).length  !== 0 && vacancyRate.compareToOtherGroupRate!==null?Math.round(Math.abs(vacancyRate.compareToOtherGroupRate)*100):'-'}}％
                    </div>
                </div>
                <div class="list">
                    <div v-if="vacancyRate.compareToLastMonthRate" class="title">
                        您比上個月空房率{{compareLastMonthIsPositive?'多':'少'}}
                    </div>
                    <div v-else class="title">
                        上個月還沒有資料
                    </div>
                    <div class="up-low" :class="{'red': !compareLastMonthIsPositive, 'blue': compareLastMonthIsPositive}">
                        {{Object.keys(vacancyRate).length  !== 0 && vacancyRate.compareToLastMonthRate!==null?Math.round(Math.abs(vacancyRate.compareToLastMonthRate)*100):'-'}}％
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizGetVacancyRate
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            vacancyRate: {}
        }
    },
    mounted () {
        this.getVacancyRate()
    },
    methods: {
        getVacancyRate: function () {
            apiBizGetVacancyRate()
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.vacancyRate = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        isPositive: function (value) {
            if(value){
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }
        }
    },
    computed: {
        compareOtherGroupIsPositive: function () {
            return this.isPositive(this.vacancyRate.compareToOtherGroupRate)
        },
        compareLastMonthIsPositive: function () {
            return this.isPositive(this.vacancyRate.compareToLastMonthRate)
        },
        ...mapGetters({
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        wordTipsHover
    }
}
</script>
<style lang="scss" scoped>
    .home-circle-chart-empty{
        width: 340px;
        height: 220px;
        padding: 20px 24px 30px;
        border-radius: 6px;
        backdrop-filter: blur(10px);
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        box-sizing: border-box;
        .header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 25px;
            .title{
                display: flex;
                font-size: 20px;
                font-weight: 500;
            }
            .tips{
                display: flex;
                align-items: center;
                >div{
                    display: flex;
                    align-items: center;
                    color: #676362;
                    font-size: 12px;
                    margin-left: 12px;
                    .dot{
                        position: relative;
                        background: #e0dfde;
                        width: 7px;
                        height: 7px;
                        border-radius: 4.5px;
                        margin-right: 4px;
                        &.empty{
                            background:#ff7f00;
                        }
                    }
                }
            }
            // .tips{
            //     position: absolute;
            //     right: 24px;
            //     >div{
            //         margin-left: 20px;
            //     }
            //     .dot.empty{
            //         background: #3942b5;
            //     }
            //     .dot.rented{
            //         background: #fc7171;
            //     }
            // }
        }
        .content{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .chart {
                position: relative;
                width: 116px;
                margin-left: 10px;
                &.empty {
                    .circle-bg {
                        stroke: #e0dfde !important;
                    }
                    .circle {
                        stroke: #e0dfde !important;
                    }
                }
                .circular-chart {
                    display: block;
                    margin: 10px auto;
                }
                .circle-bg {
                    fill: none;
                    stroke: #e0dfde;
                    stroke-width: 2.5;
                }
                .circle {
                    fill: none;
                    stroke-width: 2.5;
                    stroke-linecap: round;
                    animation: progress 1s ease-out forwards;
                    stroke: #ff7f00;
                }
                .percent{
                    position: absolute;
                    width: 100px;
                    text-align: center;
                    font-size: 28px;
                    color: #a8a5a4;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50px,-16px);
                }
            }
            .analysis{
                .list{
                    padding-top: 12px;
                    padding-bottom: 8px;
                    &.is-border{
                        border-bottom: 1px solid #f3f3f3;
                    }
                    .title{
                        font-size: 12px;
                        margin-bottom: 8px;
                    }
                    .up-low{
                        display: flex;
                        align-items: center;
                        color: #676362;
                        &.red{
                            color: #fc7171;
                        }
                        &.blue{
                            color: #71aae5;
                        }
                    }
                }
            }
          
        }
        @keyframes progress {
            0% {
                stroke-dasharray: 0 100;
            }
        }
        @keyframes bar-progress {
            0% {
                stroke-dasharray: 0 200;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalHome/home/chart/homeCircleChartEmpty.vue